import { FcSearch } from "react-icons/fc";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

const Searchbar = () => {
  const [query, setQuery] = useState("");
  const history = useHistory();

  const handleSubmit = (e) => {
    setQuery(e.target.value);
  };

  useEffect(() => {
    const params = new URLSearchParams();
    if (query) {
      params.append("products", query);
    } else {
      params.delete("products");
    }
    history.push({ search: params.toString() });
  }, [query, history]);

  return (
    <div className="flex overflow-hidden  border-2 h-3/4 border-gray-600 rounded-md justify-between items-center text-lg shadow-md">
      <input
        className=" p-2 overflow-visible border-1 h-3/4 border-gray-600 outline-none "
        type="text"
        placeholder="Search"
        value={query}
        onChange={handleSubmit}
      />

      <div className="flex justify-between bg-white shadow-md">
        <button onSubmit={handleSubmit}>
          <FcSearch className="text-3xl h-10 focus:outline-none" />
        </button>
      </div>
    </div>
  );
};

export default Searchbar;
